<template>
  <v-speed-dial-horus
    v-model="active"
    direction="bottom"
    transition="scale-transition"
  >
    <template v-slot:activator>
      <v-btn
        @click="active = !active"
        color="primary"
        fab
      >
        <v-icon v-if="active">mdi-close</v-icon>
        <v-icon v-else>mdi-tools</v-icon>
      </v-btn>
    </template>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-polygon-draw"
          @click="togglePolygonDraw"
          :color="polygonButtonColor"
          fab
          small
          v-on="on"
        >
          <v-icon v-if="isDrawingPolygon">mdi-close</v-icon>
          <v-icon v-else class="text--secondary" v-text="$vuetify.icons.values['mdiHexagonOutline']"></v-icon>
        </v-btn>
      </template>
      <span>Desenhar área</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-polyline-draw"
          @click="togglePolylineDraw"
          :color="polylineButtonColor"
          fab
          small
          v-on="on"
        >
          <v-icon v-if="isDrawingPolyline">mdi-close</v-icon>
          <v-icon v-else class="text--secondary">mdi-ruler</v-icon>
        </v-btn>
      </template>
      <span>Medir distância</span>
    </v-tooltip>
    <!-- <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-polygon-draw"
          @click="togglePolygonDraw"
          :color="polygonButtonColor"
          fab
          small
          v-on="on"
        >
          <v-icon v-if="isDrawingPolygon">mdi-close</v-icon>
          <v-icon v-else class="text--secondary" v-text="$vuetify.icons.values['mdiElevationRise']"></v-icon>
        </v-btn>
      </template>
      <span>Volumetria</span>
    </v-tooltip>     -->
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-marker-draw"
          @click="toggleMarkerDraw"
          :color="markerButtonColor"
          fab
          small
          v-on="on"
        >
          <v-icon v-if="isDrawingMarker">mdi-close</v-icon>
          <v-icon v-else class="text--secondary">mdi-map-marker-plus</v-icon>
        </v-btn>
      </template>
      <span>Pegar coordenada</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-toggle-features"
          @click="toggleFeatures"
          :color="visibilityButtonColor"
          fab
          small
          v-on="on"
        >
          <v-icon v-if="isFeaturesActive">mdi-eye-off</v-icon>
          <v-icon v-else class="text--secondary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <span>Mostrar/Esconder</span>
    </v-tooltip>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="toolbox-toggle-help"
          href="https://mappa.ag/ajuda/"
          target="_blank"
          :color="'accent'"
          fab
          small
          v-on="on"
        >
          <v-icon>mdi-help</v-icon>
        </v-btn>
      </template>
      <span>Ajuda</span>
    </v-tooltip>    
  </v-speed-dial-horus>
</template>

<script>
  import VSpeedDialHorus from "../../Helpers/Vuetify/VSpeedDial"
  import {FEATURE_GROUPS} from "../../../helpers/leaflet/constants"

  const _Map = Symbol.for("_Map")

  export default {
    name: "ToolBox",
    inject: {_Map},
    components: {VSpeedDialHorus},
    data: () => ({
      active: true,

      isFeaturesActive: true,

      isDrawingPolygon: false,
      isDrawingPolyline: false,
      isDrawingMarker: false,

      feature: null,
    }),

    methods: {
      toggleFeatures() {
        this.isFeaturesActive = !this.isFeaturesActive
        if (this.isFeaturesActive)
          this.Map.featureGroups[FEATURE_GROUPS.FEATURES].addTo(this.Map)
        else
          this.Map.featureGroups[FEATURE_GROUPS.FEATURES].remove()
      },
      togglePolygonDraw() {
        this.turnEventsOn()
        if (this.isDrawingPolygon)
          this.clearDraw()
        else {
          this.clearDraw()
          this.isDrawingPolygon = true
          this.feature = new window.L.Draw.Polygon(this.Map, {
            allowIntersection: false
          })
          this.feature.enable()
        }
      },
      togglePolylineDraw() {
        this.turnEventsOn()
        if (this.isDrawingPolyline)
          this.clearDraw()
        else {
          this.clearDraw()
          this.isDrawingPolyline = true
          var opt = {
              metric: true,
              precision: {m: 2},
          }
          this.feature = new window.L.Draw.Polyline(this.Map, opt)
          this.feature.enable()
        }
      },
      toggleMarkerDraw() {
        this.turnEventsOn()
        if (this.isDrawingMarker)
          this.clearDraw()
        else {
          this.clearDraw()
          this.isDrawingMarker = true
          this.feature = new window.L.Draw.Marker(this.Map)
          this.feature.enable()
        }
      },
      clearDraw() {
        this.isDrawingPolygon = false
        this.isDrawingPolyline = false
        this.isDrawingMarker = false

        if (this.feature) {
          this.feature.disable()
          this.feature = null
        }
      },
      escIsDown(event) {
        if (event.originalEvent.key === "Escape") {
          this.clearDraw()
          this.turnEventsOff()
          this.Map.pm.disableGlobalCutMode() 
        }
      },
      onDrawCreated() {
        this.clearDraw()
        this.turnEventsOff()
      },
      turnEventsOn() {
        this.Map.on(window.L.Draw.Event.CREATED, this.onDrawCreated)
        this.Map.on("keydown", this.escIsDown)
      },
      turnEventsOff() {
        this.Map.off(window.L.Draw.Event.CREATED, this.onDrawCreated)
        this.Map.off("keydown", this.escIsDown)
      },
    },
    computed: {
      Map: {
        get() {
          return this._Map()
        },
      },
      visibilityButtonColor() {
        return this.isFeaturesActive ? "accent" : ""
      },
      polygonButtonColor() {
        return this.isDrawingPolygon ? "accent" : ""
      },
      polylineButtonColor() {
        return this.isDrawingPolyline ? "accent" : ""
      },
      markerButtonColor() {
        return this.isDrawingMarker ? "accent" : ""
      },
      isAnyDrawActive() {
        return this.isDrawingPolygon || this.isDrawingPolyline || this.isDrawingMarker
      },
    },
  }
</script>

<style scoped>

</style>
